// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"9a648066","77":"b67115bc","216":"33580f3a","348":"5cfa1ee4","389":"a0899b66","486":"dd6bdca9","608":"b59720c6","831":"144273b3","915":"9cf5e5f0"}[chunkId] + ".chunk.js";
};